// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconClock.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconClock = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M8 0C3.57233 0 0 3.59748 0 8C0 12.4277 3.59748 16 8 16C12.4277 16 16 12.4025 16 8C16 3.57233 12.4277 0 8 0ZM12.3774 6.54088L8.25157 9.0566C8.1761 9.10692 8.07547 9.13207 8 9.13207C7.92453 9.13207 7.8239 9.10692 7.74843 9.0566C7.59748 8.95597 7.49685 8.80503 7.49685 8.62893V2.51572C7.49685 2.23899 7.72327 2.01258 8 2.01258C8.27673 2.01258 8.50314 2.23899 8.50314 2.51572V7.74843L11.8491 5.71069C12.0755 5.55975 12.4025 5.63522 12.5535 5.88679C12.6792 6.08805 12.6038 6.38994 12.3774 6.54088Z" />
  </BaseIcon>
);

export default IconClock;
